module.exports = __webpack_public_path__ + "img/product-icon-5.8aca072c.svg";